const urls = [
  {
    domain: 'bolt.aws.baxter.com',
    url: 'https://baxter-admin.aws.baxter.com',
    googleanalyticsid: 'G-ZX3626K77Q',
  },
  {
    domain: 'compounding.baxterhealthcare.com.au',
    url: 'https://compounding-admin.baxterhealthcare.com.au',
    googleanalyticsid: 'G-ZX3626K77Q',
  },
  {
    domain: 'compounding.baxter.co.nz',
    url: 'https://compounding-admin.baxterhealthcare.com.au',
    googleanalyticsid: 'G-ZX3626K77Q',
  },
  {
    domain: 'boltqa.aws.baxter.com',
    url: 'https://boltqa-admin.aws.baxter.com',
    googleanalyticsid: 'G-JXEHLQJPK8',
  },
  {
    domain: 'boltdev.aws.baxter.com',
    url: 'https://boltdev-admin.aws.baxter.com',
    googleanalyticsid: 'G-JXEHLQJPK8',
  },
  {
    domain: 'localhost:33666',
    url: 'https://baxter-admin.lndo.site',
    googleanalyticsid: 'G-JXEHLQJPK8',
  },
  {
    domain: 'localhost:8080',
    url: 'https://baxter-admin.lndo.site',
    // googleanalyticsid: 'G-JXEHLQJPK8',
    googleanalyticsid: 'G-RK55HGHN14',
  },
  {
    domain: 'localhost:8081',
    url: 'https://baxter-admin.lndo.site',
    googleanalyticsid: 'G-JXEHLQJPK8',
  },
  {
    domain: 'baxter.lndo.site:33666',
    url: 'https://baxter-admin.lndo.site:8000',
    googleanalyticsid: 'G-JXEHLQJPK8',
  },

];

export function getEnvBaseApiUrl() {
  const { host } = window.location;

  const activeUrl = urls.find((url) => url.domain === host);

  if (activeUrl && activeUrl.url !== '') {
    return activeUrl.url;
  }

  return process.env.VUE_APP_BASE_API_URL || '';
}

export function getRuntimeConfig() {
  const defaultConfig = {
    baseApiUrl: getEnvBaseApiUrl(),
    authClientId: process.env.VUE_APP_AUTH_CLIENT_ID || '',
    authClientSecret: process.env.VUE_APP_AUTH_CLIENT_SECRET || '',
  };
  // Values for this file will be populated with nginx
  return fetch('/runtimeConfig.json')
    .then(async (response) => {
      const runtimeConfig = await response.json();
      return {
        baseApiUrl: (runtimeConfig && runtimeConfig.baseApiUrl) || defaultConfig.baseApiUrl,
        authClientId: (runtimeConfig && runtimeConfig.authClientId) || defaultConfig.authClientId,
        authClientSecret: (runtimeConfig && runtimeConfig.authClientSecret) || defaultConfig.authClientSecret,
      };
    })
    .catch(() => defaultConfig);
}


export function getGAid() {
  const { host } = window.location;

  const activeUrl = urls.find((url) => url.domain === host);

  if (activeUrl && activeUrl.url !== '') {
    return activeUrl.googleanalyticsid;
  }

  return 'GAid not found';
}

export default {
  getRuntimeConfig,
  getEnvBaseApiUrl,
  getGAid,
};
